import { QueryClient } from '@tanstack/react-query';

const query = new QueryClient();

export default query;
